
import { useContext } from 'react';
import notificationsContext from './context';

const useNotify = () => useContext(notificationsContext);
export default useNotify;
